import {
  CHAMBER_ADD_LEFT,
  CHAMBER_ADD_TOP,
  CHAMBER_ADD_RIGHT,
  CHAMBER_ADD_DOWN,
  CHAMBER_ADD_ROW,
  CHAMBER_REMOVE_LEFT,
  CHAMBER_REMOVE_TOP,
  CHAMBER_REMOVE_RIGHT,
  CHAMBER_REMOVE_DOWN,
  CHAMBER_REMOVE_ROW,
  CHAMBER_SET_SELECTED,
  ADD_REMOVE_TOOL_MOVED
} from "../lib/types";

/**
 *
 * @param {function} dispatch The dispatch handler.
 * @param {string} type The action type.
 * @param {Object} payload The row and col object.
 */
function addDispatchHelper( dispatch, type, payload ) {
  /* dispatch corresponding event */
  dispatch({
    type,
    payload
  });
  /* dispatch the add-remove tool selected chamber(the one just created) */
  dispatch({
    type: CHAMBER_SET_SELECTED,
    payload
  });
}

/**
 *
 * @param {function} dispatch The dispatch handler.
 * @param {string} type The action type.
 * @param {Object} payload The row and col object.
 */
function removeDispatchHelper( dispatch, type, payload ) {
  /* remove the previous selected chamber */
  dispatch({
    type,
    payload
  });
}

export const addLeft = ( row, col ) => dispatch => {
  /* set displacement */
  row += 1;
  /* dispatch the events */
  addDispatchHelper(dispatch, CHAMBER_ADD_LEFT, {
    row,
    col
  });
};
export const addTop = ( row, col ) => dispatch => {
  /* set displacement */
  col -= 1;
  /* dispatch the events */
  addDispatchHelper(dispatch, CHAMBER_ADD_TOP, {
    row,
    col
  });
};
export const addRight = ( row, col ) => dispatch => {
  /* set displacement */
  row -= 1;
  /* dispatch the events */
  addDispatchHelper(dispatch, CHAMBER_ADD_RIGHT, {
    row,
    col
  });
};
export const addDown = ( row, col ) => dispatch => {
  /* set displacement */
  col += 1;
  /* dispatch the events */
  addDispatchHelper(dispatch, CHAMBER_ADD_DOWN, {
    row,
    col
  });
};
export const addCenter = row => dispatch => {
  /* dispatch the events */
  dispatch({
    type: CHAMBER_ADD_ROW,
    payload: {
      row
    }
  });
};
export const removeLeft = ( row, col ) => dispatch => {
  /* dispatch the events */
  removeDispatchHelper(dispatch, CHAMBER_REMOVE_LEFT, {
    row,
    col
  });
};
export const removeTop = ( row, col ) => dispatch => {
  /* dispatch the events */
  removeDispatchHelper(dispatch, CHAMBER_REMOVE_TOP, {
    row,
    col
  });
};
export const removeRight = ( row, col ) => dispatch => {
  /* dispatch the events */
  removeDispatchHelper(dispatch, CHAMBER_REMOVE_RIGHT, {
    row,
    col
  });
};
export const removeDown = ( row, col ) => dispatch => {
  /* dispatch the events */
  removeDispatchHelper(dispatch, CHAMBER_REMOVE_DOWN, {
    row,
    col
  });
};
export const removeCenter = row => dispatch => {
  /* dispatch the events */
  dispatch({
    type: CHAMBER_REMOVE_ROW,
    payload: {
      row
    }
  });
};

export const setNewPosition = ( x, y ) => dispatch => {
  dispatch({
    type: ADD_REMOVE_TOOL_MOVED,
    payload: {
      x,
      y
    }
  });
};



// WEBPACK FOOTER //
// ./src/actions/add-remove-tool-actions.js